import React, { Fragment } from 'react';
import { get, isEmpty, pick } from 'lodash/fp';
import guestAddressLine from '../../../../helpers/guestAddressLine';
import { GuestType } from '../../../../interfaces/guest';
import formatFullName from '../../../../helpers/formatFullName';
import { VIEW_ADDRESS } from '../../../../constants/permissions/guest';
import { viewAccess } from '../../../../helpers/permission';
import AccessControl from '../../../../components/AccessControl';

const GuestDetails = ({ guest, ...props }) => {
  const address = guestAddressLine(guest, true, true);
  const fullName = formatFullName(
    pick(['firstname', 'middlename', 'lastname'], guest)
  );
  return (
    <div {...props}>
      <h5>
        <span>#{get('id', guest)}</span>
        {' - '}
        {fullName}
      </h5>
      {!isEmpty(address) && (
        <Fragment>
          <strong>Address:</strong>
          <AccessControl allowOnlyFor={viewAccess(VIEW_ADDRESS)}>
            <div>{address.line1}</div>
          </AccessControl>
          <div>{address.line2}</div>
        </Fragment>
      )}
    </div>
  );
};

GuestDetails.propTypes = {
  guest: GuestType.isRequired
};

export default GuestDetails;
